(function ready(fn) {
    // eslint-disable-next-line
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    let isMobile = false;
    const arrowCssAfterElementWidth = 7; // width of arrow css ::after element
    const mobileWindowWidth = 600; // screen width where mobile ends
    const fixedVerticalDistanceToArrow = 10;
    const tooltips = document.querySelectorAll('i.tooltip');

    function updateArrowPosition() {
        if (window.innerWidth < mobileWindowWidth) {
            isMobile = true;
        } else {
            isMobile = false;
        }

        if (isMobile) {
            [...tooltips].forEach((item) => {
                let positionLeft = 15; // default left position of arrow css ::after element in pixels
                let positionBottom = 0;
                const rectTooltip = item.getBoundingClientRect();
                const halfOfTooltipWidth = rectTooltip.width / 2;

                let parent = item.parentElement;
                let parentPositionLeft = 0;
                if (parent) {
                    parent.style.position = 'relative';
                    const rectParent = parent.getBoundingClientRect();
                    parentPositionLeft = rectParent.left;
                    positionBottom = Math.round(rectParent.height - item.offsetTop + fixedVerticalDistanceToArrow);
                }

                positionLeft = Math.round(rectTooltip.left - parentPositionLeft + halfOfTooltipWidth - arrowCssAfterElementWidth);
                item.style.setProperty('--positionLeft', `${positionLeft}px`);
                if(positionBottom > 0) item.style.setProperty('--positionBottom', `${positionBottom}px`);
            });
        }
    }

    window.addEventListener('resize', updateArrowPosition);
    setTimeout(() => {
        updateArrowPosition();
    }, 500);
});